<template>
  <div id="container">
    <div class="product-status">
      <el-form class="search-style">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-form-item>
              <el-select v-model="queryParams.column" @change="changeColumn">
                <el-option
                  :label="item.name"
                  :value="item.value"
                  v-for="item in quoteCollectList"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <!-- <el-select v-if="queryParams.column==='staffUsename'" v-model="queryParams.value">
                <el-option
                  :label="item.staffUsename"
                  :value="item.staffUsename"
                  v-for="(item,index) in principalList"
                  :key="index"
                ></el-option>
              </el-select>-->
              <el-select v-if="queryParams.column==='interfaceType'" v-model="queryParams.value">
                <el-option label="后台添加" value="后台添加"></el-option>
                <el-option label="API接口" value="API接口"></el-option>
              </el-select>
              <el-input v-else v-model="queryParams.value" placeholder="请输入关键词"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="onSearch">搜索</el-button>
            <el-button @click="onReset" plain>重置</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="box-table" :style="{height:tableHeight+'px'}">
        <el-table
          ref="multipleTable"
          :data="quoteCollectTable"
          tooltip-effect="dark"
          :max-height="tableHeight"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
          border
        >
          <el-table-column prop="suName" label="供应商" min-width="132" show-overflow-tooltip>
            <template slot-scope="scope">
              <div
                class="skip line-limit-length"
                @click="onEdit(scope.row)"
              >{{scope.row.suName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="totalQuote" label="总报价">
            <template slot-scope="scope">{{scope.row.totalQuote }}</template>
          </el-table-column>
          <el-table-column prop="valid" label="有效报价">
            <template slot-scope="scope">{{scope.row.valid }}</template>
          </el-table-column>
          <el-table-column prop="invalid" label="过期报价">
            <template slot-scope="scope">{{scope.row.pastCount }}</template>
          </el-table-column>
          <el-table-column prop="interfaceType" label="对接类型">
            <template slot-scope="scope">{{ scope.row.interfaceType || '--'}}</template>
          </el-table-column>
          <el-table-column label="最后更新时间" min-width="132">
            <template slot-scope="scope">{{scope.row.lastEdit|dateFilterL}}</template>
          </el-table-column>
          <el-table-column prop="lastResult" show-overflow-tooltip label="最后更新结果" min-width="132">
            <template slot-scope="scope">{{ scope.row.lastResult || '--'}}</template>
          </el-table-column>
          <el-table-column label="操作日志">
            <template slot-scope="scope">
              <div class="skip" @click="onOperationLog(scope.row)">查看</div>
            </template>
          </el-table-column>
          <el-table-column prop="staffUsename" label="负责人">
            <template slot-scope="scope">{{ scope.row.staffUsename || '--'}}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="210">
            <template slot-scope="scope">
              <el-button type="text" @click="onSeeDetail(scope.row)">查看明细</el-button>
              <el-button type="text" @click="getEmpty(scope.row)">清空报价</el-button>
              <el-button type="text" @click="onToLead(scope.row)">导入</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
      <operation-log ref="operationLogRefs"></operation-log>
      <allocation @onRefresh="getList" ref="allocationRefs"></allocation>
      <quote-lead-in @onRefresh="getList" ref="quoteLeadInRef"></quote-lead-in>
      <!-- 清空报价 -->
      <el-dialog :visible.sync="disableDialog" class="dialog-address" width="437px" title="清空报价">
        <div>
          <el-form :model="form" label-width="100px">
            <el-form-item label="报价类型：">
              <el-select v-model="form.state" style="width:80%">
                <el-option
                  :label="item.label"
                  :value="item.id"
                  v-for="(item,index) in emptyList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-center">
          <el-button @click="onSubmit" type="primary">确定</el-button>
          <el-button @click="disableDialog=false">取消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { quoteCollectList, emptyList } from './utils/data'
import {
  queryBySupplierOfferSummary,
  queryAllByChargeStaffId,
  deleteSupplierOffer
} from '@/api/supplier/supplierManage'
import pagination from '@/components/pagination'
import operationLog from './dialog/operationLog'
import allocation from './dialog/allocation'
import quoteLeadIn from '@/components/leadIn/quoteLeadIn'
export default {
  components: {
    'operation-log': operationLog,
    allocation,
    pagination,
    'quote-lead-in': quoteLeadIn
  },
  data() {
    return {
      emptyList,
      form: {},
      radio: '',
      disableDialog: false,
      tableHeight: window.innerHeight - 320,
      queryParams: {
        column: 'suName',
        value: ''
      },
      quoteCollectList: [],
      quoteCollectTable: [],
      principalList: [], // 负责人
      total: 0,
      currentPage: 1, // 当前页
      pageSize: 30, // 分页页数
      loadingTable: false,
      serchList: [],
      suId: ''
    }
  },
  watch: {
    queryParams(val) {
      if (!val.column) {
        this.$set(this.queryParams, 'column', 'suName')
      }
    }
  },
  created() {
    this.quoteCollectList = quoteCollectList
    this.getList()
  },
  methods: {
    // 报价列表
    getList() {
      this.loadingTable = true
      const params = {
        criteriaVoList: [],
        queryPageName: ''
      }
      if (this.queryParams.value) {
        params.criteriaVoList = [...this.serchList]
      }
      queryBySupplierOfferSummary(this.currentPage, this.pageSize, params).then(
        res => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.quoteCollectTable = res.data.obj.records
            this.total = res.data.obj.total
          } else {
            this.$message.error(res.data.msg)
          }
        }
      )
    },
    // 选择搜索条件
    changeColumn(val) {
      delete this.queryParams.value
    },
    // 获取负责人
    getQueryAllByChargeStaffId() {
      queryAllByChargeStaffId().then(res => {
        if (res.data.code === 200) {
          this.principalList = res.data.obj
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 导入
    onToLead(row) {
      this.$refs.quoteLeadInRef.onLeadIn(row.suId)
    },
    // 重置
    onReset() {
      this.serchList = []
      this.queryParams = {}
      this.currentPage = 1
      this.pageSize = 30
      this.getList()
    },
    onSearch() {
      if (this.queryParams.column && this.queryParams.value) {
        this.pageSize = 30
        this.currentPage = 1
        this.serchList = [this.queryParams]
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    // 供应商详情
    onEdit(row) {
      this.$router.push({
        path: '/crm/supplier/supplierEdit',
        query: { id: row.suId }
      })
    },
    // 操作日志
    onOperationLog(row) {
      this.$refs.operationLogRefs.onOperation(row.suId)
    },
    // 查看明细
    onSeeDetail(row) {
      this.$router.push({
        path: '/crm/supplier/quoteDetail',
        query: { id: row.suId }
      })
    },
    // 清空报价提示框
    getEmpty(row) {
      this.suId = row.suId
      this.disableDialog = true
    },
    // 确定清空报价
    onSubmit(row) {
      console.log(this.form.state)
      if (this.form.state) {
        deleteSupplierOffer(this.suId, this.form.state).then(res => {
          if (res.data.code === 200) {
            this.$message.success('清空成功')
            this.disableDialog = false
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        this.$message.error('请选择报价类型')
      }
    },

    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 分页页数
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    // 分页码数
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
.supplier-list {
  .supplier-list-form {
    padding: 10px 30px;
  }
}
</style>
